import useScrollReveal from "@/hooks/useScrollReveal";
import TopRail from "./components/TopRail";
import Header from "./components/Header";
import Hero from "./components/Hero";
import EntryChannels from "./components/EntryChannels";
import LatestUpdates from "./components/LatestUpdates";
import CollectionIndex from "./components/CollectionIndex";
import AntiLostGuide from "./components/AntiLostGuide";
import FaqSection from "./components/FaqSection";
import SiteFooter from "./components/SiteFooter";

export default function Home() {
  useScrollReveal();

  return (
    <div className="min-h-screen bg-background-50 font-sans text-foreground-950">
      <TopRail />
      <Header />
      <main>
        <Hero />
        <EntryChannels />
        <LatestUpdates />
        <CollectionIndex />
        <AntiLostGuide />
        <FaqSection />
      </main>
      <SiteFooter />
    </div>
  );
}